import { looksLikeSqlite } from "./sqlite";
import type { LegacyRejectCode, LegacySourceId } from "./types";

/**
 * Legacy origin detection from file BYTES.
 *
 * Important: SQLite **is the legitimate and main format**. The published app
 * has no export or backup, so the file the user copies
 * from their device (or read by native command) is exactly
 * `databases/highlight`, un SQLite binario.
 *
 * Regla de oro: **nunca fallar en silencio**. Si no reconocemos el fichero,
 * we return an explicit code so the UI explains WHAT happened and WHAT to do.
 */

export type LegacyDetection =
  | { ok: true; source: LegacySourceId }
  | { ok: false; code: LegacyRejectCode; detail: string };

const decoder = new TextDecoder("utf-8", { fatal: false });

/** Do the bytes look like JSON text? */
function looksLikeJson(bytes: Uint8Array): boolean {
  // Checking the first non-whitespace character is enough: redux-persist dump is an object.
  for (const byte of bytes.subarray(0, 64)) {
    if (byte === 0x20 || byte === 0x09 || byte === 0x0a || byte === 0x0d || byte === 0xef) {
      continue;
    }
    return byte === 0x7b; // '{'
  }
  return false;
}

/** Decodes bytes as UTF-8 text (for redux-persist source). */
export function decodeText(bytes: Uint8Array): string {
  return decoder.decode(bytes);
}

export function detectLegacySource(bytes: Uint8Array): LegacyDetection {
  if (bytes.length === 0) {
    return { ok: false, code: "empty-file", detail: "The file is empty." };
  }
  if (looksLikeSqlite(bytes)) {
    return { ok: true, source: "highlight-sqlite-v1" };
  }
  if (looksLikeJson(bytes)) {
    return { ok: true, source: "redux-persist-v1" };
  }
  return {
    ok: false,
    code: "unrecognised-file",
    detail:
      "This is neither the legacy `highlight` SQLite database nor the " +
      "`persist-rootTest5` preferences file.",
  };
}
